import { root } from "utils/typedRoute";

export const ROOT = root();
